import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchUnreadMessageCount } from '../services/player/Messaging.tsx';

const PRIORITY_DATA_PATHS = ['/weekly-figures', '/pendingBets'];
const PRIORITY_ROUTE_DEFER_MS = 2_000;

const isPriorityDataPath = (path: string) =>
  PRIORITY_DATA_PATHS.some((p) => path === p || path.startsWith(`${p}/`));

/** One-shot unread count. Deferred on Weekly/Pending so those screens get the network first. */
export function useUnreadMessages(userName: string | undefined) {
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNewMessageToast, setShowNewMessageToast] = useState(false);
  const onPriorityRoute = isPriorityDataPath(location.pathname);

  useEffect(() => {
    if (!userName) {
      setUnreadCount(0);
      return;
    }

    let cancelled = false;
    const delayMs = onPriorityRoute ? PRIORITY_ROUTE_DEFER_MS : 0;

    const timer = window.setTimeout(() => {
      void fetchUnreadMessageCount(userName)
        .then((count) => {
          if (!cancelled) setUnreadCount(count);
        })
        .catch((error) => {
          console.error('Error loading unread messages:', error);
          if (!cancelled) setUnreadCount(0);
        });
    }, delayMs);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [userName, onPriorityRoute]);

  return {
    unreadCount,
    showNewMessageToast,
    dismissToast: () => setShowNewMessageToast(false),
  };
}
